/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-12 17:16:03 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-06-06 09:33:04
 */
<template>
  <div class="packed_index">
    <el-form :inline="true" :model="searchMsg" class="demo-form-inline search">
      <el-form-item label="打印时间：">
        <el-date-picker
          @blur="blurPicker"
          style="width:300px"
          v-model="searchMsg.date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单信息查询:">
        <el-input
          placeholder="收/寄件人姓名、手机号、运单号"
          v-model="searchMsg.key_word"
          class="input-with-select"
          @clear="inputClear"
          clearable
          style="width:240px"
        ></el-input>
      </el-form-item>
      <el-form-item label="打印人：">
        <el-select v-model="searchMsg.printer" placeholder="请选择">
          <el-option
            v-for="item in printerArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单来源：">
        <el-select v-model="searchMsg.order_source" placeholder="请选择">
          <el-option
            v-for="item in comSource"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运单号获取：">
        <el-select v-model="searchMsg.mail_get_type" placeholder="请选择">
          <el-option
            v-for="item in maigetArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="operation">
        <el-button
          @click="search('search')"
          :loading="isSearch"
          type="primary"
          plain
          icon="el-icon-search"
        >查询</el-button>
        <el-button @click="reset()" type="primary" plain icon="el-icon-delete">清空</el-button>
      </el-form-item>
    </el-form>
    <div class="table" >
      <div class="topHeader">
        <label>
          共
          <span class="total">{{ table_total }}</span>条记录符合
        </label>
      </div>
      <el-table ref="table" size="mini" :height="tableHeight" v-loading="tableLoading"
      border stripe fit highlight-current-row :data="tableData" style="width:100%" class="tableBox">
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column label="创建时间" align="center">
            <template slot-scope="scope">
               <span>{{ scope.row.create_time | formatDate }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="打印时间" align="center">
            <template slot-scope="scope">
               <span>{{ scope.row.print_time | formatDate }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="收件信息" align="left">
            <template slot-scope="scope">
              {{ scope.row.receiver_name }} {{ scope.row.receiver_phone }}，
              <br />
              {{ scope.row.receiver_province }} {{ scope.row.receiver_city }}
              {{ scope.row.receiver_district }} {{ scope.row.receiver_address }} 
            </template>
        </el-table-column>
        <el-table-column label="寄件信息" align="left">
            <template slot-scope="scope">
              {{ scope.row.sender_name }} {{ scope.row.sender_phone }}，
              <br />
              {{ scope.row.sender_province }} {{ scope.row.sender_city }}
              {{ scope.row.sender_district }} {{ scope.row.sender_address }}
            </template>  
        </el-table-column>
        <el-table-column label="备注" align="center">
            <template slot-scope="scope">
               <span>{{ scope.row.item_note || "- -" }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="标记码" prop="ticket_id" align="center">
        </el-table-column>
        <!-- <el-table-column label="运单号" prop="thinking" align="center">
        </el-table-column>
        <el-table-column label="增值服务" prop="thinking" align="center">
        </el-table-column>
        <el-table-column label="订单来源" prop="thinking" align="center">
        </el-table-column> -->
        <el-table-column label="操作" align="center">
            <template slot-scope="scope">
               <el-button type="text" @click="toogleExpand(scope.row, '展开')">详情</el-button>
               <el-button type="text" @click="golog(scope.row.mail_no)">查看物流</el-button>   
            </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
            <template slot-scope="props">
                <!-- <el-row>
                    <el-col :span="6">
                    <div class="grid-content">
                        <span>订单ID：</span>
                        <span>{{ props.row.order_id }}</span>
                    </div>
                    </el-col>
                    <el-col :span="6">
                    <div class="grid-content">
                        <span>物品类型：</span>
                        <span>{{ props.row.item_type }}</span>
                    </div>
                    </el-col>
                    <el-col :span="6">
                    <div class="grid-content">
                        <span>订单来源：</span>
                        <span>{{ props.row.order_source | comeFrom}}</span>
                    </div>
                    </el-col>
                </el-row>
                <div  @click="toogleExpand(props.row, '收起')">收起</div> -->


                <div class="info">
                  <div class="info_left">
                    <!-- <div> -->
                      <el-row>
                        <el-col :span="8">
                          <div class="grid-content">
                            <span>订单ID：</span>
                            <span>{{ props.row.order_id }}</span>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content">
                            <span>物品类型：</span>
                            <span>{{ props.row.item_type }}</span>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content">
                            <span>订单来源：</span>
                            <span>{{ props.row.order_source | comeFrom}}</span>
                          </div>
                        </el-col>
                      </el-row>
                    <!-- </div> -->
                  </div>
                  <div class="info_right">
                    <div @click="toogleExpand(props.row, '收起')">
                      收起
                      <img src="@/assets/images/top.png" alt />
                    </div>
                  </div>
                </div>
            </template>
        </el-table-column>
      </el-table>

      <!-- <table v-loading="tableLoading">
        <thead>
          <tr>
            <td style="width:30px">序号</td>
            <td>创建时间</td>
            <td>打印时间</td>
            <td>收件信息</td>
            <td>寄件信息</td>
            <td>备注</td>
            <td>标记码</td>
            <td>运单号</td>
            <td class="operation">操作</td>
          </tr>
        </thead>
        <tbody v-if="!haveData">
          <tr>
            <td colspan="9">
              <div class="noBody">
                <img src="@/assets/images/nodata.png" alt />
              </div>
            </td>
          </tr>
        </tbody>
        <tbody >
         <template v-for="item,index in tableData">
          <tr class="showTr" v-if="haveData">
            <td style="width:30px">{{index+1}}</td>
            <td style="width:90px">{{ item.create_time | formatDate }}</td>
            <td style="width:90px">{{ item.print_time | formatDate }}</td>
            <td class="mark">
              {{ item.receiver_name }} {{ item.receiver_phone }}，
              <br />
              {{ item.receiver_province }} {{ item.receiver_city }}
              {{ item.receiver_district }} {{ item.receiver_address }}
            </td>
            <td class="mark">
              {{ item.sender_name }} {{ item.sender_phone }}，
              <br />
              {{ item.sender_province }} {{ item.sender_city }}
              {{ item.sender_district }} {{ item.sender_address }}
            </td>
            <td>{{ item.item_note || "- -" }}</td>
            <td>{{ item.ticket_id}}</td>
            <td style="text-align:left;" class="courier">
              <div>{{ item.mail_platform_name }}</div>
              <div class="cope">
                {{ item.mail_no
                }}
                <span
                  v-clipboard:copy="item.mail_no"
                  v-clipboard:success="onCopy"
                >复制</span>
              </div>
            </td>
            <td class="operation">
              <div class="operation_div">
                <div @click="showDet(index)">详情</div>
                <div @click="golog(item.mail_no)">查看物流</div>
              </div>
            </td>
          </tr>
          <transition name="el-zoom-in-top" v-if="haveData && !$store.state.isLoading">
            <tr v-show="table_index.indexOf(index) !== -1" class="det">
              <td colspan="9">
                <div class="info">
                  <div class="info_left">
                    <div>
                      <el-row>
                        <el-col :span="8">
                          <div class="grid-content">
                            <span>订单ID：</span>
                            <span>{{ item.order_id }}</span>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content">
                            <span>物品类型：</span>
                            <span>{{ item.item_type }}</span>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content">
                            <span>订单来源：</span>
                            <span>{{ item.order_source | comeFrom}}</span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div class="info_right">
                    <div @click="showDet(index)">
                      收起
                      <img src="@/assets/images/top.png" alt />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </transition>             
        </template>   
        </tbody>
      </table> -->
    </div>
    <div class="pages">
      <div class="pages_left"></div>
      <div class="pages_right">
        <el-pagination
          v-if="showPage"
          prev-text="上一页"
          next-text="下一页"
          :current-page="currPage"
          :page-size="page_size"
          @size-change="changeSizes"
          :page-sizes="[30, 50, 100]"
          @current-change="currentPage"
          layout="sizes,prev, pager, next, jumper"
          :total="table_total"
        ></el-pagination>
        <div slot="append" class="sure" type="primary">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import home from "@/api/home";
import util from "@/util/util";
export default {
  name: "printed",
  data() {
    return {
      searchMsg: {
        printer: 0, // 打印人
        date: "",
        sort:2,
        mail_get_type:0,
        order_source:0,
        key_word: "" //搜索框
      },
      select: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
        ],
        disabledDate: time => {
          let nowDate = new Date();
          let oneDay = 1000 * 60 * 60 * 24;
          let oneMonthLater = new Date(nowDate.getTime() - oneDay * 90);
          return time.getTime() > nowDate || time.getTime() < oneMonthLater;
        }
      },
      tableData: [], // 数据
      table_index: [], //展开
      table_total: 0, //总数
      page_size: 30,
      currPage: 1, //当前页
      showPage: true,
      isSearch: false, //搜索中...
      forSearch: false, //是否是搜索
      haveData: true,
      tableLoading : false,
      printerArr:[
        {label:'全部',value:0},
        {label:'提交给业务员',value:1},
        {label:'本人打印',value:2},
      ],
      comSource:[
        {label:'全部',value:0},
        {label:'寄快递创建',value:101},
        {label:'电脑导入',value:102},
        {label:'邀请下单',value:103},
      ],
      maigetArr:[
        {label:'全部',value:0},
        {label:'已获取',value:1},
        {label:'未获取',value:2},
        {label:'已取消',value:3},
      ],
      limitTip:false,
      currentIndex:null,
      tableHeight:300,
    };
  },

  filters: {
    formatDate(time) {
      var date = new Date(time);
      return util.formatTime(date, "yyyy-MM-dd hh:mm:ss");
    },
    comeFrom(data){
      var string = '';
      if(data == 101){
        string = '寄快递创建';
      }else if(data == 102){
        string = '电脑导入';
      }else if(data == 103){  
        string = '邀请下单';
      }else{
        string = '';
      }
      return string
    }
  },
  watch: {
  },
  beforeCreate() {
    this.accountId = util.getCookie("account_id");
  },

  mounted(){
    this.loadData();
    util.getTableHeight(this,document.querySelector('.tableBox'),100) ;
    window.addEventListener('resize',()=>{
    util.getTableHeight(this,document.querySelector('.tableBox'),100);     
    });    
  },
  deactivated(){
    window.removeEventListener('resize',()=>{
    util.getTableHeight(this,document.querySelector('.tableBox'),100);  
    }) 
  },
  components: {
    //组件声明
    // queryYwy
  },

  methods: {
		toogleExpand(row, text) {
				let $table = this.$refs.table;
        if (text == "展开") {
          this.tableData.map((item) => {
            if (row.order_id != item.order_id) {
              $table.toggleRowExpansion(item, false)
            }
          })
          this.currentIndex = row.order_id
        } else {
         this.currentIndex = null;
        }
				$table.toggleRowExpansion(row)
		},

    blurPicker(){
      const start_time = this.searchMsg.date[0];
      const end_time = this.searchMsg.date[1];
      if(start_time && end_time && (new Date(end_time).getTime()-new Date(start_time).getTime() >  2.592e9)){
        this.$message.warning('起始时间与结束时间跨度不可大于31天~');
        this.limitTip = true; 
      }else{
        this.limitTip = false;
      }
    },
    //排序更改
    sortChange(value){
      this.loadData();
    },
    //查看物流信息
    golog (e) {
      const url = this.$router.resolve({path: '/logistics', query: {mailNo: e}})
      window.open(url.href,'_blank')
    },
    /** 加载更多 */
    loadData() {
      this.tableLoading = true;
      let self = this;
      let postMsg = {
        current_page: this.currPage,
        page_size: this.page_size,
        start_time:"2021-07-10 10:10:10",
        end_time:"2021-07-20 10:10:10",
        order_source: 101, //订单来源0-全部， 101-寄快递创建， 102-电脑导入， 103-邀请下单
        service_type: 1, //增值服务0-全部，1-无，2-到付,3-智橙网
        key_word: "",  //关键字 运单号-姓名-电话-地址
        logistics_status: 0,
      };
      home.signDetails(this, postMsg).then(res => {
        if (res.success) {
          self.tableLoading = false;
          self.table_total = res.data.total;
          self.$store.state.printedNum = res.data.total;
          self.tableData = res.data.list;
          if (res.data.list.length > 0) {
            this.haveData = true;
          } else {
            this.haveData = false;
          }
        } else {
        }
      });
    },
    /** 展示详情 */
    showDet(index) {
      if (this.table_index.indexOf(index) === -1) {
        this.table_index.push(index);
      } else {
        let idx = this.table_index.indexOf(index);
        if (idx > -1) {
          this.table_index.splice(idx, 1);
        }
      }
    },

    /** 搜索 */
    search(flag) {
      if(this.limitTip){
        this.$message.warning('起始时间与结束时间跨度不可大于31天~');
        return
      }
      this.isSearch = true;
      this.forSearch = true;
      this.table_index = [];
      if (flag) {
        var postMsg = {
          current_page: 1,
          page_size: this.page_size,
          print_status: 1
        };
        this.currPage = 1;
      } else {
        var postMsg = {
          current_page: this.currPage,
          page_size: this.page_size,
          print_status: 1
        };
      }
      this.loadData()
      setTimeout(()=>{
        this.isSearch = false;  
      },500)
    },
    /** 重置 */
    reset() {
      this.table_index = [];
      this.searchMsg = {
        printer: 0, // 打印人
        date: "",
        mail_get_type:0,
        order_source:0,
        key_word: "", //搜索框
        sort:2
      };
      this.select = "";
      this.forSearch = false;
      this.currPage = 1;
      this.page_size = 30;
      this.loadData();
    },
    /** 改变条数 */
    changeSizes(e) {
      this.page_size = e;
      this.currPage = 1;
      if (this.forSearch) {
        this.search();
      } else {
        this.loadData();
      }
    },
    /** 当前页 */
    currentPage(e) {
      this.currPage = e;
      if (this.forSearch) {
        this.search();
      } else {
        this.loadData();
      }
    },
    /** 一键复制 */
    onCopy(e) {
      this.$message({
        message: "快递单号: " + e.text + " 复制成功",
        type: "success"
      });
    },
    inputClear() {
      this.searchMsg.select_text = "";
    }
  }
};
</script>

<style lang="stylus" scoped>
.packed_index {
  .search {
    padding: 30px 40px 0 40px;
    border-bottom: 1px solid #e8e8e8;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .input-with-select {
      width: 300px;

      /deep/ .el-select .el-input {
        width: 150px;
        color: #606266;
      }

      /deep/ .el-input-group__prepend {
        background-color: #fff;
      }

      /deep/ .el-input__inner {
        color: #606266;
        padding-right: 16px;
      }
    }

    .operation {
      margin-left: auto;
    }
  }

  .table {
    width: 100%;
    // min-height: 60vh;
    background: #fff;
    box-sizing: border-box;
    padding 0 40px 20px;

    .noBody {
      min-height: 40vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 16px;

      img {
        width: 255px;
        height: 255px;
      }
    }

    label {
      color: #666666;

      .total {
        color: #409EFF;
      }
    }

    .topHeader {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 60px;

      label {
        color: #666666;

        .total {
          color: #409EFF;
        }
      }

      .sortMethod {
        margin-right: 20px;
        font-size: 14px;
      }

      .export {
        margin-left: 50px;

        a {
          color: #409EFF;
        }
      }
    }
  }


  .info {
    height: auto;
    display: flex;

    .info_left {
      flex: 1;
      display: flex;
      align-items: center;
      text-align: left;

      .el-row {
        margin-bottom: 10px;
      }

      >div {
        padding-left: 40px;
        width: 80%;

        .grid-flex {
          display: flex;

          & span:nth-child(1) {
            flex-basis: 15%;
          }

          & span:nth-child(2) {
            flex-basis: 85%;
          }
        }

        .grid-flex2 {
          display: flex;

          & span:nth-child(1) {
            flex-basis: 8%;
          }

          & span:nth-child(2) {
            flex-basis: 92%;
          }
        }

        span {
          color: #000;
        }
      }
    }

    .info_right {
      flex-basis: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2288F8;

      >div {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &:active {
          transform: scale(0.95);
        }

        img {
          width: 12px;
          height: 6px;
          margin-left: 8px;
        }
      }
    }
  }
  .pages {
    display: flex;
    justify-content: space-between;
    margin-bottom: 80px;
    margin-right 20px;

    .pages_right {
      display: flex;

      .sure {
        display: inline-block;
        width: 48px;
        height: 28px;
        margin: 0 5px;
        font-size: 12px;
        text-align: center;
        line-height: 28px;
        border-radius: 4px;
        border: 1px solid rgba(220, 220, 220, 1);
        cursor: pointer;
      }

      .sure:hover {
        background: #2288f8;
        border: 1px solid #2288f8;
        color: #fff;
      }
    }

    /deep/ .el-pager .number {
      border: 1px solid #DCDCDC;
      color: #666666;
      font-size: 14px;
      margin: 0 5px;
      height: 30px;
      min-width: 30px;
      border-radius: 5px;

      &:hover {
        background: rgba(0, 0, 0, 0.2);
        color: #ffffff;
      }
    }

    /deep/ .el-pager .active {
      transition: all 0.3s;
      background: #2288F8;
      border: 1px solid #2288F8;
      color: #ffffff;

      &:hover {
        background: #2288F8;
        border: 1px solid #2288F8;
        color: #ffffff;
      }
    }

    /deep/ .btn-prev, /deep/.btn-next {
      border: 1px solid #DCDCDC;
      color: #666666;
      font-size: 14px;
      padding: 0 6px;
      min-width: 60px;
      height: 30px;
      border-radius: 5px;

      &:hover {
        background: #2288F8;
        border: 1px solid #2288F8;
        color: #ffffff;
      }
    }
  }
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

table th, table td {
  border: 1px solid #ddd;
  padding: 5px;
}

table th {
  font-weight: inherit;
  border-bottom-width: 2px;
  border-bottom-color: #ccc;
}
</style>
